let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8T7VK")).then(() => parcelRequire('be02C'));